export default __webpack_public_path__ + "static/media/test.7c17ef77.mp4";